import {_request, _requestForm} from "./api";

export const add = (date) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: 'club', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (date,document_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: `club/${document_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (document_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `club/${document_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'club/item', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'club', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listSportsHall = (date) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'club/sports-hall', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const editSportsHall = (sportsHallId, params) => {
    return _request({
        target: `club/sports-hall/${sportsHallId}`,
        method: 'PUT',
        params
    });
};

export const addSportsHall = params => {
    return _request({
        target: 'club/sports-hall',
        method: 'POST',
        params
    });
};

export const listColorTypes = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'club/color-types', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const listUserClub = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'club/user-clubs', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
